import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../_services/dialog.service';
import { Observable } from 'rxjs';
import { tap, mergeMap } from 'rxjs/operators';
import { CouponService } from '../_services/coupon.service';
import { Coupon } from '../_models/Coupon';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-coupon',
  templateUrl: './coupons.component.html',
  styleUrls: ['../_shared/base.management.component.css']
})

export class CouponsComponent implements OnInit {
  public loading = true;
  public coupons: Coupon[] = [];
  public displayCoupons: Coupon[] = [];

  public searchText: string;


  constructor(private router: Router,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private couponService: CouponService,
    private spinner: NgxSpinnerService) {

  }

  ngOnInit() {
    this.loadCoupons().subscribe();
  }

  downloadPkPass(coupon: any) {
    this.dialogService.confirm(
      'Download Pkpass',
      'Viewing pkpass files natively requires an Apple device. Continue?',
      this.viewRef).then((result) => {
        if (result === true) {
          const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
          a.href = coupon.pkPassUrl;
          a.download = coupon.offer;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      });
  }

  viewGoogleOffer(coupon: any) {
    this.dialogService.confirm(
      'View Google Offer',
      'Viewing this Google Offer will open a new window, please be sure that you signed into your Google account, and that your browser is not blocking pop-ups or ads. Continue?',
      this.viewRef).then((result) => {
        if (result === true) {
          window.open(coupon.googlePayUrl, '_blank');
        }
      });
  }

  public search() {
    if (!this.searchText) {
      return;
    }
    const search = this.searchText.toLowerCase();
    this.displayCoupons = this.coupons.filter(c => c.couponTitle.toLowerCase().indexOf(search) !== -1 || !search);
  }

  public deleteCoupon(id: number) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to delete this coupon?', this.viewRef).then(r1 => {
      if (r1) {
        this.loading = true;
        this.spinner.show();

        this.couponService.checkCoupon(id).subscribe(r => {
          if (r) {
            this.delete(id);
          } else {
            this.spinner.hide();
            this.loading = false;
            this.dialogService.confirm(
              'Coupon in Use', 
              'There are one or more services using this coupon, are you sure you want to continue?', 
              this.viewRef).then(r2 => { 
                if (r2) {
                  this.loading = true;
                  this.spinner.show();
                  this.delete(id);
                }
            });
          }
        });
      }
    });
  }

  delete(id) {
    this.couponService
    .deleteCoupon(id)
    .pipe(
      tap(
        () => {
          this.loading = false;
          this.spinner.hide();
        },
        () => {
          this.loading = false;
          this.spinner.hide();
          this.dialogService.alert('Error', 'Unable to delete coupon', this.viewRef);
        }
      ),
      mergeMap(() => this.loadCoupons())
    ).subscribe();
  }

  public editCoupon(id: number) {
    this.router.navigate(['/portal/coupons/', id]);
  }

  private loadCoupons(): Observable<any> {
    this.spinner.show();
    return this.couponService.listCoupons().pipe(
      tap(
        data => {
          this.coupons = this.displayCoupons = data;
          this.spinner.hide();
          this.loading = false;
        },
        () => {
          this.dialogService.alert('Error', 'Unable to load coupons', this.viewRef);
          this.spinner.hide();
          this.loading = false;
        }
      )
    );
  }

  public newCoupon() {
    this.router.navigate(['/portal/coupons/create']);
  }
}
